export default {
  getCookie: function(cookieName) {
    let cookies = decodeURIComponent(document.cookie);

    if (cookies) {
      cookies = cookies.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while(cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }

        if(cookie.indexOf(cookieName) === 0){
          return cookie.substring(cookieName.length+1, cookie.length);
        }
      }
    }

    return "";
  },
  setCookie: function(cookieName, cookieValue, override = true) {
    // check cookie isn't already set. If so, override if override is true
    if (!override && this.getCookie(cookieName) !== "") {
        return;
    }

    // ensure cookie is replaced if override is true
    if (override) {
        this.deleteCookie(cookieName);
    }

    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + 24 * 60 * 60 * 1000);
    let expires = "expires=" + expiryDate.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  },
  // remove cookie (path=/ only)
  deleteCookie: function(cookieName) {
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },

  /**
   * Deletes all variants of a cookie that may exist with different paths/domains.
   * Use when a single deleteCookie may miss cookies set with different attributes.
   */
  deleteAllNamedCookies: function(cookieName) {
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    const pathsToTry = ["/"];
    const hostname = typeof window !== "undefined" ? window.location.hostname : "";

    const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
    const pathSegments = pathname.split("/").filter(Boolean);
    for (let i = 1; i <= pathSegments.length; i++) {
      pathsToTry.push("/" + pathSegments.slice(0, i).join("/"));
    }
    if (pathname !== "/" && !pathsToTry.includes(pathname)) {
      pathsToTry.push(pathname);
    }

    const domainsToTry = [""];
    if (hostname && hostname !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
      const parts = hostname.split(".");
      for (let i = 1; i < parts.length; i++) {
        domainsToTry.push("; domain=." + parts.slice(i).join("."));
      }
    }

    for (const domain of domainsToTry) {
      for (const path of pathsToTry) {
        document.cookie = cookieName + "=;" + expires + "; path=" + path + domain;
      }
    }
  }
};
